var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"termsOfUse"},[_c('h3',{staticClass:"termsOfUse__title"},[_vm._v("Termos de Uso")]),_vm._v(" "),_c('article',{staticClass:"termsOfUse__wrapper",domProps:{"innerHTML":_vm._s(_vm.termsOfUse)}})])}
var staticRenderFns = []

export { render, staticRenderFns }